import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  OnDestroy,
  OnInit
} from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { map, take } from "rxjs/operators";
import {
  AddressSummaryService,
  AddressSummary
} from "@onsip/common/services/api/resources/addressSummary/address-summary.service";
import { GroupAddressWithExtensions } from "../groupsPage/groups-page.component";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { E2eLocators } from "@onsip/e2e/configs/locators";

@Component({
  selector: "onsip-group-shelf-view",
  templateUrl: "./group-shelf-view.component.html",
  styleUrls: ["../groupShelfEdit/group-shelf-edit.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GroupShelfViewComponent implements OnInit, OnChanges, OnDestroy {
  @Input() group!: GroupAddressWithExtensions;
  @Output() clickedEditing = new EventEmitter<void>();

  groupMembers: Array<{ name: string }> = [];
  groupExtensions: Array<{ name: string }> = [];
  transferAddress: AddressSummary | undefined;
  mobileView!: Observable<boolean>;
  E2eLocators = E2eLocators;

  private unsubscriber = new Subscription();

  constructor(
    private addressSummaryService: AddressSummaryService,
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit(): void {
    this.mobileView = this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium])
      .pipe(map(res => res.matches));
  }

  ngOnChanges(changes: any) {
    if (!changes.group || changes.group.previousValue === changes.group.currentValue) return;
    //map members and extensions
    this.groupMembers = this.group.groupMemberAddresses.map(member => {
      return { name: member.address.name };
    });
    this.groupExtensions = this.group.extensions.map(extension => {
      return { name: extension };
    });

    this.unsubscriber.add(
      this.addressSummaryService.orgState.pipe(take(1)).subscribe(addressSummaries => {
        this.transferAddress = addressSummaries.find(
          address => address.addressId === this.group.defaultAddress?.addressId
        );
      })
    );
  }

  ngOnDestroy() {
    this.unsubscriber.unsubscribe();
  }
}
